import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["toggle", "modal", "guestControl"];

  connect() {
    this.initializeFromHiddenInputs();
    this.updateGuestsCount();
    this.boundHideModal = this.hideModal.bind(this);
    document.addEventListener("click", this.boundHideModal);
  }
  
  initializeFromHiddenInputs() {

    this.adultsHiddenInputs = document.querySelectorAll('input[name="adults"]');
    this.childrenHiddenInputs = document.querySelectorAll('input[name="children"]');
    this.petsHiddenInputs = document.querySelectorAll('input[name="pets"]');

    this.totalGuestsCountDisplayEls = document.querySelectorAll('.total-guest-count');

    this.guestControlEls = document.querySelectorAll('.guest-count');

    const adultsValue = this.adultsHiddenInputs.length > 0 ? this.adultsHiddenInputs[0].value : 0;
    const childrenValue = this.childrenHiddenInputs.length > 0 ? this.childrenHiddenInputs[0].value : 0;
    const petsValue = this.petsHiddenInputs.length > 0 ? this.petsHiddenInputs[0].value : 0;

    if (this.adultsHiddenInputs.length > 0 && adultsValue) {
      this.adultsHiddenInputs.forEach(input => input.value = adultsValue);
    }
    if (this.childrenHiddenInputs.length > 0 && childrenValue) {
      this.childrenHiddenInputs.forEach(input => input.value = childrenValue);
    }
    if (this.petsHiddenInputs.length > 0 && petsValue) {
      this.petsHiddenInputs.forEach(input => input.value = petsValue);
    }


    if (this.guestControlEls.length > 0) {
      this.guestControlEls.forEach(element => {
        if (element.dataset.guest === "adults" && adultsValue) {
          element.textContent = adultsValue;
        }
        if (element.dataset.guest === "children" && childrenValue) {
          element.textContent = childrenValue;
        }
        if (element.dataset.guest === "pets" && petsValue) {
          element.textContent = petsValue;
        }
      });
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundHideModal);
  }

  toggle(event) {
    event.stopPropagation();
    if (this.hasModalTarget) {
      this.modalTarget.classList.toggle("hidden");
      this.syncExpanded();
    }
  }

  hideModal(event) {
    if (this.hasModalTarget && this.hasToggleTarget) {
      if (!this.modalTarget.contains(event.target) && !this.toggleTarget.contains(event.target)) {
        this.modalTarget.classList.add("hidden");
        this.syncExpanded();
      }
    }
  }

  // Keep the toggle's aria-expanded in sync with the popover so screen readers
  // announce whether the guest selector is open (WCAG 4.1.2). Only the <button>
  // variant (_guests.html) opts in by declaring aria-expanded in markup; other
  // templates still render the toggle as a role-less <div>, where aria-expanded
  // is not a permitted attribute — skip those.
  syncExpanded() {
    if (this.hasToggleTarget && this.hasModalTarget && this.toggleTarget.hasAttribute("aria-expanded")) {
      const expanded = !this.modalTarget.classList.contains("hidden");
      this.toggleTarget.setAttribute("aria-expanded", expanded ? "true" : "false");
    }
  }

  increaseGuestCount(event) {
    event.stopPropagation();
    const countElement = event.currentTarget.nextElementSibling;
    if (countElement) {
      const currentCount = parseInt(countElement.textContent);
      countElement.textContent = currentCount + 1;
      this.updateGuestsCount();
    }
  }

  decreaseGuestCount(event) {
    event.stopPropagation();
    const countElement = event.currentTarget.previousElementSibling;
    if (countElement) {
      const currentCount = parseInt(countElement.textContent);
      if (currentCount > 0) {
        countElement.textContent = currentCount - 1;
        this.updateGuestsCount();
      }
    }
  }

  getLocalGuestControlCounts() {
    // Get the guest counts from the local guest count elements for this controller instance
    // Local to this controller instance
    const adultsElement = this.guestControlTarget.querySelector('.guest-count[data-guest="adults"]');
    const childrenElement = this.guestControlTarget.querySelector('.guest-count[data-guest="children"]');
    const petsElement = this.guestControlTarget.querySelector('.guest-count[data-guest="pets"]');

    // Get local counts
    const adultsCount = adultsElement ? parseInt(adultsElement.textContent) : 1;
    const childrenCount = childrenElement ? parseInt(childrenElement.textContent) : 0;
    const petsCount = petsElement ? parseInt(petsElement.textContent) : 0;

    const totalGuests = adultsCount + childrenCount;
    return { adultsCount, childrenCount, petsCount, totalGuests };
  }

  updateGuestsCount() {
    // Update all guest controllers on the page to keep them in sync

    const { adultsCount, childrenCount, petsCount, totalGuests } = this.getLocalGuestControlCounts();

    const adultsValue = adultsCount > 0 ? adultsCount : '';
    const childrenValue = childrenCount > 0 ? childrenCount : '';
    const petsValue = petsCount > 0 ? petsCount : '';
  
    if (this.totalGuestsCountDisplayEls) {
      this.totalGuestsCountDisplayEls.forEach(span => {
        if (totalGuests > 0) {
          span.textContent = `${totalGuests} Guests`;
        } else {
          span.textContent = `Guests`;
        }
      });
    }

    if (this.adultsHiddenInputs.length > 0 && adultsValue) {
      this.adultsHiddenInputs.forEach(input => input.value = adultsCount);
    }
    if (this.childrenHiddenInputs.length > 0 && childrenValue) {
      this.childrenHiddenInputs.forEach(input => input.value = childrenCount);
    }
    if (this.petsHiddenInputs.length > 0 && petsValue) {
      this.petsHiddenInputs.forEach(input => input.value = petsCount);
    }

  }
}
